// @flow
import * as React from "react";
import styled, { css } from "styled-components";
import { fontSize, rtl } from "../common/styled-mixins";
import Gettext from "../common/Gettext";
import _Scrollable from "../common/Scrollable";

import SocialTradingIcon from "../Icons/SocialTrading";

const Header = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  padding: 0 14px;
  padding-bottom: 12px;
`;

const IconContainer = styled.div`
  margin-bottom: 5px;
  color: #feac00;
`;

const Title = styled.div`
  margin-bottom: 5px;
  font-size: ${fontSize(16)};
  color: ${({ theme }) => theme.foreground};
`;

const Subtitle = styled.div`
  font-size: ${fontSize(12)};
  color: #99959d;
`;

const Table = styled.div`
  flex-grow: 2;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const TableHeader = React.memo(styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 30px;
  padding: 0 16px 0 21px;
  background-color: ${({ theme }) =>
    theme.mode === "light" ? theme.background : theme.mainDark};
`);

export const TableItem = React.memo(styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  font-size: ${fontSize(10)};
  color: #99959d;
  box-sizing: border-box;

  ${({ theme }) =>
    theme.locale !== "ar" &&
    css`
      :first-letter {
        text-transform: uppercase;
      }
    `};

  &:not(:last-of-type) {
    ${rtl("margin-right", "10px")};
  }

  ${({ column }) => {
    switch (column) {
      case "assets":
        return css`
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          min-width: 98px;
        `;
      case "trader":
        return css`
          min-width: 45px;
        `;
      case "profit":
        return css`
          flex-grow: 1;
          ${rtl("text-align", "right")};
        `;
      default:
        return css``;
    }
  }};
`);

const Scrollable = styled(_Scrollable)`
  flex-grow: 2;
`;

const Bar = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  width: 4px;
  margin: 2px;
  background-color: #feac00;
`;

const List = styled.div`
  padding: 0 16px;
`;

type Props = {
  children: React.Node,
  hide?: React.Node
};

const Sidebar = React.memo(({ children, hide }: Props) => (
  <React.Fragment>
    <Header>
      <IconContainer>
        <SocialTradingIcon />
      </IconContainer>
      <Title>
        <Gettext>Successful traders</Gettext>
      </Title>
      <Subtitle>
        <Gettext>Trader activity in real time</Gettext>
      </Subtitle>
    </Header>
    <Table>
      <TableHeader>
        <TableItem column="assets">
          <Gettext>Assets</Gettext>
        </TableItem>
        <TableItem column="trader">
          <Gettext>trader</Gettext>
        </TableItem>
        <TableItem column="profit">
          <Gettext>PROFIT</Gettext>
        </TableItem>
      </TableHeader>
      <Scrollable bar={<Bar />}>
        <List>{children}</List>
      </Scrollable>
    </Table>
    {hide}
  </React.Fragment>
));

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/SocialTrading/Social.js